import * as React from "react";
import { DisplayLabel } from "./DisplayLabel";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export const UnansweredDisplay = () => {
  const [, theme] = useStyletron();
  return <DisplayLabel color={theme.colors.contentTertiary}> -</DisplayLabel>;
};
